export default __webpack_public_path__ + "static/media/SVGMhuComp.5130b697.svg";